/* The mockup's `.scrim` + `.dialog.palette`, `.pal-input`, `.pal-list`, `.pal-opt`, `.pal-group`, `.pal-foot`. */
.scrim {
  position: fixed;
  inset: 0;
  z-index: var(--z-dialog);
  display: grid;
  place-items: start center;
  padding: 10vh var(--space-4) var(--space-4);
  overflow: auto;
  background: var(--scrim);
}

.palette {
  inline-size: min(600px, 100%);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--surface-raised);
  color: var(--text);
  box-shadow: var(--shadow-dialog);
}

.inputRow {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: 0 var(--space-4);
  border-bottom: 1px solid var(--border);
  color: var(--text-subtle);
}

.input {
  flex: 1;
  block-size: 48px;
  border: 0;
  background: transparent;
  color: var(--text);
  font-size: var(--font-size-16);
}

.input:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -2px;
}

.list {
  max-block-size: 360px;
  overflow: auto;
  padding: var(--space-1);
}

.group {
  padding: var(--space-2) 10px var(--space-1);
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.option {
  display: flex;
  align-items: center;
  gap: 10px;
  block-size: 36px;
  padding: 0 10px;
  border-radius: var(--radius-control);
  font-size: var(--font-size-13);
  cursor: pointer;
}

.option svg {
  color: var(--text-subtle);
}

.option[aria-selected="true"] {
  background: var(--state-active);
}

.optionLabel {
  flex: 1;
}

.empty {
  padding: var(--space-6);
  color: var(--text-muted);
  font-size: var(--font-size-13);
  text-align: center;
}

.empty:empty {
  display: none;
}

.foot {
  display: flex;
  gap: var(--space-4);
  padding: var(--space-2) var(--space-4);
  border-top: 1px solid var(--border);
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}
